export const TestIds = {
    AEDU_ONBOARD_PRE_REQUS_LINK: "aedu-onboard-pre-reqs-link",
    SANDFIRE_CHECKLIST_LINK: "aedu-onboard-pre-reqs-link",
};
